'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { SearchSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { PAGE_SIZE } from '../../constants';
import { buildPaginationMeta } from '../../utils';
import { SearchSectionShell } from '../SearchSectionShell';
import { GiftCardSkeletonList } from './GiftCardSkeletonList';
import { GiftFilter } from './GiftFilter';
import { GiftList } from './GiftList';
interface GiftSearchProps {
  keyword: string;
  page: number;
  onPageChange: (page: number) => void;
  isFilterOpen: boolean;
  onCloseFilter: () => void;
  categoryIds: number[];
  institutionIds: number[];
  onToggleCategory: (id: number) => void;
  onToggleInstitution: (id: number) => void;
  onReset: () => void;
}
export function GiftSearch(t0) {
  const $ = _c(31);
  const {
    keyword,
    page,
    onPageChange,
    isFilterOpen,
    onCloseFilter,
    categoryIds,
    institutionIds,
    onToggleCategory,
    onToggleInstitution,
    onReset
  } = t0;
  const {
    entry,
    isEntryResolved
  } = useWebviewTypeEntry();
  let t1;
  if ($[0] !== categoryIds || $[1] !== entry || $[2] !== institutionIds || $[3] !== keyword || $[4] !== page) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/gift-products"]({
      query: {
        searchKeyword: keyword,
        categoryIdList: categoryIds.length > 0 ? categoryIds : undefined,
        institutionIdList: institutionIds.length > 0 ? institutionIds : undefined,
        page,
        size: PAGE_SIZE,
        entry
      }
    });
    $[0] = categoryIds;
    $[1] = entry;
    $[2] = institutionIds;
    $[3] = keyword;
    $[4] = page;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== isEntryResolved || $[7] !== t1) {
    t2 = {
      ...t1,
      enabled: isEntryResolved,
      placeholderData: keepPreviousData
    };
    $[6] = isEntryResolved;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const {
    data,
    isLoading
  } = useQuery(t2);
  const t3 = data?.context?.totalCount;
  let t4;
  if ($[9] !== t3) {
    t4 = buildPaginationMeta(t3);
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const meta = t4;
  let t5;
  if ($[11] !== categoryIds || $[12] !== institutionIds || $[13] !== isFilterOpen || $[14] !== onCloseFilter || $[15] !== onReset || $[16] !== onToggleCategory || $[17] !== onToggleInstitution) {
    t5 = <GiftFilter isDrawerOpen={isFilterOpen} onCloseDrawer={onCloseFilter} onApplyDrawer={onCloseFilter} categoryIds={categoryIds} institutionIds={institutionIds} onToggleCategory={onToggleCategory} onToggleInstitution={onToggleInstitution} onReset={onReset} />;
    $[11] = categoryIds;
    $[12] = institutionIds;
    $[13] = isFilterOpen;
    $[14] = onCloseFilter;
    $[15] = onReset;
    $[16] = onToggleCategory;
    $[17] = onToggleInstitution;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SearchSideAdBanner />;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== data?.context?.contents || $[21] !== isLoading) {
    t7 = isLoading ? <GiftCardSkeletonList count={PAGE_SIZE} /> : <GiftList items={data?.context?.contents ?? []} />;
    $[20] = data?.context?.contents;
    $[21] = isLoading;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== meta || $[24] !== onPageChange || $[25] !== page || $[26] !== t7) {
    t8 = <SearchSectionShell meta={meta} page={page} pageSize={PAGE_SIZE} onPageChange={onPageChange}>{t7}</SearchSectionShell>;
    $[23] = meta;
    $[24] = onPageChange;
    $[25] = page;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t5 || $[29] !== t8) {
    t9 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" leftAside={t5} rightAside={t6}>{t8}</DesktopPageShell>;
    $[28] = t5;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
}